"use strict";
import i from "./index.es99.js";
import g from "./index.es113.js";
const m = (o) => o instanceof g ? { ...o } : o;
function b(o, a) {
  a = a || {};
  const f = {};
  function s(t, n, r, d) {
    return i.isPlainObject(t) && i.isPlainObject(n) ? i.merge.call({ caseless: d }, t, n) : i.isPlainObject(n) ? i.merge({}, n) : i.isArray(n) ? n.slice() : n;
  }
  function u(t, n, r, d) {
    if (i.isUndefined(n)) {
      if (!i.isUndefined(t))
        return s(void 0, t, r, d);
    } else return s(t, n, r, d);
  }
  function c(t, n) {
    if (!i.isUndefined(n))
      return s(void 0, n);
  }
  function e(t, n) {
    if (i.isUndefined(n)) {
      if (!i.isUndefined(t))
        return s(void 0, t);
    } else return s(void 0, n);
  }
  function l(t, n, r) {
    if (r in a)
      return s(t, n);
    if (r in o)
      return s(void 0, t);
  }
  const p = {
    url: c,
    method: c,
    data: c,
    baseURL: e,
    transformRequest: e,
    transformResponse: e,
    paramsSerializer: e,
    timeout: e,
    timeoutMessage: e,
    withCredentials: e,
    withXSRFToken: e,
    adapter: e,
    responseType: e,
    xsrfCookieName: e,
    xsrfHeaderName: e,
    onUploadProgress: e,
    onDownloadProgress: e,
    decompress: e,
    maxContentLength: e,
    maxBodyLength: e,
    beforeRedirect: e,
    transport: e,
    httpAgent: e,
    httpsAgent: e,
    cancelToken: e,
    socketPath: e,
    responseEncoding: e,
    validateStatus: l,
    headers: (t, n, r) => u(m(t), m(n), r, !0)
  };
  return i.forEach(Object.keys({ ...o, ...a }), function(t) {
    const n = p[t] || u, r = n(o[t], a[t], t);
    i.isUndefined(r) && n !== l || (f[t] = r);
  }), f;
}
export {
  b as default
};
//# sourceMappingURL=index.es102.js.map
